import { TextLink } from '@neo4j-ndl/react';

import { LATEST_PLUGIN_VERSION } from '../constants';

export const PluginDownloadLinks = () => {
  return (
    <ol className="mx-4 list-disc">
      <li>
        <TextLink
          href={`https://dist.neo4j.org/fleet-management/${LATEST_PLUGIN_VERSION}/neo4j-fleet-management-plugin-${LATEST_PLUGIN_VERSION}-v4.jar`}
          type="external"
        >
          Neo4j Version 4.4.x
        </TextLink>
      </li>
      <li>
        <TextLink
          href={`https://dist.neo4j.org/fleet-management/${LATEST_PLUGIN_VERSION}/neo4j-fleet-management-plugin-${LATEST_PLUGIN_VERSION}-v5.jar`}
          type="external"
        >
          Neo4j Version 5.x
        </TextLink>
      </li>
      <li>
        <TextLink
          href={`https://dist.neo4j.org/fleet-management/${LATEST_PLUGIN_VERSION}/neo4j-fleet-management-plugin-${LATEST_PLUGIN_VERSION}-v2025.jar`}
          type="external"
        >
          Neo4j Version 2025.x
        </TextLink>
      </li>
    </ol>
  );
};
